export default "__VITE_ASSET__jnPV4bkeVR3dO1CwxGX1uA__"